import React, { useCallback, useMemo, useState } from 'react';

import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { useSetRecoilState } from 'recoil';
import ClaimRewardsResultAtom from '../../../../recoil/cashout/ClaimRewardsResultAtom';
import useHttpRequest from '../../../api/HttpRequest';
import ConvertSubmission from './ConvertSubmission';
import ConvertSuccess from './ConvertSuccess';
import ClaimRewardProcessing from '../../common/ClaimRewardProcessing';
import ClaimRewardError from '../../common/ClaimRewardError';
import ClaimRewardsStatuses from '../../common/Constants';

export default function ConvertConfirmationModal({ selectedPackage, paymentProvider, onClose }) {
  const httpRequest = useHttpRequest();

  const setClaimRewardsResult = useSetRecoilState(ClaimRewardsResultAtom);

  const [status, setStatus] = useState(ClaimRewardsStatuses.idle);

  const sendConvert = useCallback(async (evt) => {
    evt?.preventDefault?.();

    // Prevent multiple submissions
    if (status !== ClaimRewardsStatuses.idle) return;

    setStatus(ClaimRewardsStatuses.processing);
    try {
      const result = await httpRequest.send(`/web-payments/convert/orders/${uuidv4()}`, {
        method: 'PUT',
        body: {
          provider: paymentProvider,
          productId: selectedPackage.productId,
        },
        additionalHeaders: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      console.log('Convert order submitted successfully: ', result);
      setStatus(ClaimRewardsStatuses.success);
      setClaimRewardsResult({
        status: ClaimRewardsStatuses.success,
        updatedAt: Date.now(),
      });
    } catch (err) {
      console.log('Unable to submit convert order due to: ', err);
      setStatus(ClaimRewardsStatuses.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentProvider, selectedPackage]);

  const content = useMemo(() => {
    switch (status) {
      case ClaimRewardsStatuses.processing:
        return <ClaimRewardProcessing />;
      case ClaimRewardsStatuses.success:
        return <ConvertSuccess onClose={onClose} />;
      case ClaimRewardsStatuses.error:
        return <ClaimRewardError onClose={onClose} />;
      default:
        return (
          <ConvertSubmission
            selectedPackage={selectedPackage}
            handleSubmit={sendConvert}
            handleClose={onClose}
          />
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, selectedPackage, paymentProvider]);

  return (
    <div
      id="convert-confirmation"
      className="phoenix-simple-dialog-view modal member-diamonds-cash-confirm show"
      aria-hidden="false"
    >
      <div className="modal-backdrop fade" />
      <div className="modal-dialog">
        <div className="modal-content modal-content-sm">
          {content}
        </div>
      </div>
    </div>
  );
}

ConvertConfirmationModal.propTypes = {
  selectedPackage: PropTypes.shape({
    productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  paymentProvider: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
